import React, { useEffect, useState } from "react";
import { Form, Col, Button } from "react-bootstrap";
import useSelectProyecto from "../../../../hooks/useSelectProyectos";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

const FiltroProyectos = ({ setValores, loading, children }) => {
  const [error, setError] = useState(null);
  const history = useHistory();
  const queryString = new URLSearchParams(window.location.search);
  const idProyectoQ = queryString.get("proyecto");

  const [proyectoSelect, SelecProyectos] = useSelectProyecto(idProyectoQ);
  const formik = useFormik({
    initialValues: {
      idEvento: idProyectoQ || null,
    },
    onSubmit: (valores) => {
      history.push(`?proyecto=${valores.idEvento}`);
    },
  });

  useEffect(() => {
    if (idProyectoQ) {
      setValores({
        idEvento: idProyectoQ,
      });
    }
  }, [idProyectoQ]);

  useEffect(() => {
    if (proyectoSelect) {
      setError(null);
      formik.setFieldValue("idEvento", proyectoSelect.id_proyecto);
    } else {
      formik.setFieldValue("idEvento", null);
    }
  }, [proyectoSelect]);

  useEffect(() => {
    const valores = {
      idEvento: idProyectoQ || null,
    };
    history.push(`?proyecto=${valores.idEvento}`);
  }, []);

  return (
    <div className="FormularioFiltroMatricula" style={{ display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap' }}>
      <div style={{ minWidth: '280px' }}>
        <Form.Label>Productos</Form.Label>
        <SelecProyectos />
        {error && <Form.Text className="text-danger">{error}</Form.Text>}
      </div>
      <Form onSubmit={formik.handleSubmit} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Button type="submit" disabled={loading} className="btn-icon">
          <FontAwesomeIcon icon={faSearch} />
          Buscar
        </Button>
      </Form>
      {children}
    </div>
  );
};

export default FiltroProyectos;
